$(document).ajaxError(function (event, jqxhr, settings, thrownError) {
   if (jqxhr.status === 401) {
        document.location.href = '/';
   }
});
$.fn.select2.defaults.set( "theme", "bootstrap4" );

window.initComponents = _.debounce(function () {
    console.log('initComponents...')

    makeSqureBox();

    $('[data-toggle="popover"]').each((index, el) => {
        let conf = $.extend({
            "trigger": "hover",
            "container": "body",
            "placement": "left",
            "html": true
        }, $(el).data());

        $(el).popover('dispose')
        $(el).popover(conf);
    })


    $('[data-toggle="tooltip"]').each((index, el) => {

        let conf = $.extend({
            "trigger": "hover",
            "placement": "top",
            "delay": { show: 100, hide: 100 },
            "html": true,
            "container": 'body'
        }, $(el).data());

        $(el).tooltip(conf);
    })


    $('.bootstrap-toggle').each((index, el) => {

        $(el).bootstrapToggle();
    })

    $("[id^='tooltip']").tooltip('hide');

    // $(".select2").select2();
    $('.select2').each(function(index, el){
        let conf = $.extend({}, $(el).data('config'));
        $(el).select2(conf);
    });

    $('.datepicker').each(function(index, el){
        let _this = $(el);

        let format = $(el).attr('date-format');
        format = format? format : "Y-m-d G:i K";

        let config = {
            enableTime: true,
            dateFormat: format,
        }

        flatpickr(el, config);
    });

    $('.year-month-picker').each(function(index, el){
        let _this = $(el);
        let el_config = $(el).data('config');

        let conf = $.extend({
            shorthand: true, //defaults to false
            dateFormat: "F Y", //defaults to "F Y"
            altFormat: "F Y", //defaults to "F Y"
            // theme: "dark" // defaults to "light"
        }, el_config);

        let picker_config = {
            disableMobile: "true",
            plugins : [
                new monthSelectPlugin(conf)
            ]
        }

        flatpickr(el, picker_config);
    });

    $('.summernote').each((index, el) => {


        if($(el).data('summernote'))  {
            return;
        }

        $(el).removeData('summernote');
        let onChange = $(el).attr('onchange');
        let onBlur = $(el).attr('onblur');

        let data = $(el).data();


        let conf = $.extend({
            maxHeight: 300,
        }, data);


        $(el).summernote(conf);// same as above

        if(onChange) {
            $(el).attr('onchange', onChange)
            $(el).on("summernote.change", function (e) {   // callback as jquery custom event
                $(el).change()
            });
        }

        if(onBlur) {
            $(el).attr('onblur', onChange)
            $(el).on("summernote.blur", function (e) {   // callback as jquery custom event
                $(el).blur()
            });
        }
    })

    let clipboards = new ClipboardJS('.copy-btn');

}, 200)

if(typeof debounce != 'function') {
    window.debounce = (func, timeout = 300) => {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
    }
}


window.dt_options = {

	"initComplete" : function(settings, data){
        initComponents();
    },

    "drawComplete" : function(settings, data){
        initComponents();
    },

    "serverSideExportAction" : function(e, dt, button, config) {
        var self = this;
        var oldStart = dt.settings()[0]._iDisplayStart;
        var oldText = $(button[0]).html();

        $(button[0]).html('<i class="fa fa-spinner fa-spin"></i>');

        dt.one('preXhr', function (e, s, data) {
            // Just this once, load all data from the server...
            data.start = 0;
            data.length = 2147483647;
            dt.one('preDraw', function (e, settings) {
                // Call the original action function
                if (button[0].className.indexOf('buttons-copy') >= 0) {
                    $.fn.dataTable.ext.buttons.copyHtml5.action.call(self, e, dt, button, config);
                } else if (button[0].className.indexOf('buttons-excel') >= 0) {
                    $.fn.dataTable.ext.buttons.excelHtml5.available(dt, config) ?
                        $.fn.dataTable.ext.buttons.excelHtml5.action.call(self, e, dt, button, config) :
                        $.fn.dataTable.ext.buttons.excelFlash.action.call(self, e, dt, button, config);
                } else if (button[0].className.indexOf('buttons-csv') >= 0) {
                    $.fn.dataTable.ext.buttons.csvHtml5.available(dt, config) ?
                        $.fn.dataTable.ext.buttons.csvHtml5.action.call(self, e, dt, button, config) :
                        $.fn.dataTable.ext.buttons.csvFlash.action.call(self, e, dt, button, config);
                } else if (button[0].className.indexOf('buttons-pdf') >= 0) {
                    $.fn.dataTable.ext.buttons.pdfHtml5.available(dt, config) ?
                        $.fn.dataTable.ext.buttons.pdfHtml5.action.call(self, e, dt, button, config) :
                        $.fn.dataTable.ext.buttons.pdfFlash.action.call(self, e, dt, button, config);
                } else if (button[0].className.indexOf('buttons-print') >= 0) {
                    $.fn.dataTable.ext.buttons.print.action(e, dt, button, config);
                }
                dt.one('preXhr', function (e, s, data) {
                    // DataTables thinks the first item displayed is index 0, but we're not drawing that.
                    // Set the property to what it was before exporting.
                    settings._iDisplayStart = oldStart;
                    data.start = oldStart;
                });
                // Reload the grid with the original page. Otherwise, API functions like table.cell(this) don't work properly.
                setTimeout(dt.ajax.reload, 0);
                // Prevent rendering of the full data to the DOM
                return false;
            });
        });
        // Requery the server with the new one-time export settings
        dt.ajax.reload(function () {
            $(button[0]).html(oldText);
        });
    }
}

window.addEventListener('initComponents',function () {
    makeSqureBox();
    initComponents();
})


$(document).ready(function(){

    $('.counter').each(function () {
        var $this = $(this);
        jQuery({ Counter: 0 }).animate({ Counter: $this.text() }, {
            duration: 1000,
            easing: 'swing',
            step: function () {
                $this.text(Math.ceil(this.Counter));
            }
        });
    });

    initComponents();
});

$.fn.dataTable.ext.buttons.downloadCsvFromServer = {
    text: 'Download CSV',
    action: function ( e, dt, node, config ) {
        DataTablesDownloadFromServer(dt, 'csv');
    }
}

window.DataTablesDownloadFromServer = function (dataTable, type) {
    let url = dataTable.ajax.url();
    let params = dataTable.ajax.params();

    delete params.start;
    delete params.length;

    params['dataTablesDownloadType'] = type;

    if(!url || !type) {
        return;
    }

    window.location.href = url + '?' + toQueryString(params);
}

window.toQueryString = function(obj, prefix) {
    var str = [],
        p;
    for (p in obj) {
        if (obj.hasOwnProperty(p)) {
            var k = prefix ? prefix + "[" + p + "]" : p,
                v = obj[p];
            str.push((v !== null && typeof v === "object") ?
                toQueryString(v, k) :
                encodeURIComponent(k) + "=" + encodeURIComponent(v));
        }
    }
    return str.join("&");
}


window.selectDeferedImage = function(_this) {

    let imageListView = $(_this).closest('.image-list-grid-view');
    let countContainer = imageListView.find('.image-count');
    let isChecked =  $(_this).is(':checked');
    let count_txt = countContainer.text();
    let count = parseInt(count_txt);
    count = isNaN(count) ? 0 : count;

    if( isChecked ) {
        count++;
        countContainer.text(count);
        $(_this).parent().addClass('selected')
    } else {
        count--;
        countContainer.text(count <= 0 ? 0 : count);
        $(_this).parent().removeClass('selected');
    }

    count <= 0 ? countContainer.parent().addClass('all-selected') : countContainer.parent().removeClass('all-selected')
}

window.makeSqureBox = function() {
    $('.squre-box').each(function () {
        $(this).height( $(this).width() );
    });
}

makeSqureBox();


window.addEventListener('resize', function(event) {
    makeSqureBox()
});


window.addEventListener('console_log', event => {
    console.log(event.detail);
});


window.addEventListener('atert_message', event => {
    alert(event.detail);
});

$(document).on('shown.bs.popover', '[data-toggle="popover"]', function () {
    let el = this;

    setTimeout(function () {
        let closeEvent = $(el).data('close-event');
        let id = $(el).attr('aria-describedby');
        let replaceContent = $(el).attr('data-replace-content');

        if(id && $("#"+id).length > 0) {
            if(replaceContent) {
                $('.popover-body', $("#"+id)).html(replaceContent);
            }

            if(closeEvent) {
                $("#"+id).off(closeEvent);
                $("#"+id).on(closeEvent, function () {
                    $(el).popover('hide')
                })
            }
        }
    }, 10);
});

$(document).click(function (e) {

    let time = (new Date()).getTime();
    let popoverEl = $(e.target).attr('data-toggle') == 'popover' ? $(e.target) : ($(e.target).parent().attr('data-toggle') == 'popover' ? $(e.target).parent() : null);

    if(popoverEl) {
        $('[data-toggle="popover"]').each(function (i) {
            if(!$(this).data('popover-id')) {
                $(this).data('popover-id', 'popover-' + time + '-' + (i+1))
            }

            if(popoverEl.data('popover-id') != $(this).data('popover-id')) {
                $(this).popover('hide')
            }
        })

        return;
    }

    let popover = $(e.target).hasClass('popover') ? $(e.target) : $(e.target).closest('.popover');

    popoverEl = null;
    if(popover.length > 0) {
        let id = popover.attr('id');
        popoverEl = $("[aria-describedby=\"" + id + "\"]");

        if(popoverEl.length == 0 && !popoverEl.data('popover-id')) {
            popoverEl = null;
        }
    }



    $('[data-toggle="popover"]').each(function (i) {
        if(!$(this).data('popover-id')) {
            $(this).data('popover-id', 'popover-' + time + '-' + (i+1))
        }

        if(!popoverEl || popoverEl.data('popover-id') != $(this).data('popover-id')) {
            $(this).popover('hide')
        }
    })

    $('.popover.show').each(function (i) {
        let id = $(this).attr('id');
        let popoverEl = $("[aria-describedby=\"" + id + "\"]");

        if(!id || popoverEl.length == 0) {
            $(this).remove()
        }
    })

});
